<template>
  <div class="card-home1">
    <div class="top">
      <nav-bar titleText="卡包" fontColor="#333333" @goBack="goBack"></nav-bar>
    </div>
    <div class="recharge-card-box">
      <div class="recharge">
        <img  src="" alt="" ref="cardimg">
      </div>
      <div class="bottom-box">
        <div class="money" @click="skip()">
          <span>余额</span>
          <span v-if="!show"><img src="../../assets/shared-hotel/money.png" alt="">{{ `${cartMoney}` }}</span>
          <img v-if="show" src="../../assets/shared-hotel/star.png" alt="">
        </div>
        <div class="eyes">
          <img v-if="! show" src="../../assets/shared-hotel/openeye.png" alt="" @click="changelook()">
          <img v-if="show" src="../../assets/shared-hotel/offeye.png" alt="" @click="changelook()">
        </div>
      </div>
    </div>
    <div class="info-box">
      <div class="recording" @click="goToRecord">
        <span>使用记录</span>
        <img src="../../assets/shared-hotel/rightback.png" alt="">
      </div>
      <div class="store" @click="goToStore">
        <span>适用门店</span>
        <img src="../../assets/shared-hotel/rightback.png" alt="">
      </div>
      <div class="help" @click="goHelp">
        <span>使用帮助</span>
        <img src="../../assets/shared-hotel/rightback.png" alt="">
      </div>
    </div>

  </div>
</template>


<script>
import navBar from './components/navBar'
export default {
  name:"cardHome",
  data() {
    return {
      cartMoney: 0,
      show: false,
    }
  },
  components:{
    navBar,
  },
  mounted(){
      if(localStorage.getItem('cardbalanceshow')){
          this.show=localStorage.getItem('cardbalanceshow')=='true'?true:false
      }
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    
    // if (! this.$route.query.jingdu || ! this.$route.query.weidu) {
    //   // this.$toast('经纬度没传')
    //   this.goBack()
    // }

    localStorage.setItem('longitude', this.$route.query.longitude)
    localStorage.setItem('latitude', this.$route.query.latitude)

    this.getCardInfo()
  },
  computed: {
  },
  methods:{
      changelook(){
        this.show=!this.show;
        localStorage.setItem('cardbalanceshow',this.show);
    },
    goBack() {
      this.params(3, 3, 'goHome')
    },
    getCardInfo() {
      this.$api.get("/offshop/member/canteen/membership-card").then(data => {
        this.cartMoney =data.balance
        this.$refs.cardimg.src = data.style
        if(!data || !data.balance) {
          this.cartMoney = 0
        }
      })
    },
    goToRecord() {
      this.$router.push('/sharedHotel/usageRecord')
    },
    goToStore() { 
      this.$router.push({
        path:'/sharedHotel/store1',
        query:{
          long: this.$route.query.longitude,
          lat: this.$route.query.latitude,
        }
      })
    },
    goHelp() {
      this.$router.push('/sharedHotel/usingHelp')
    },
    skip(){
      this.$router.push('/sharedHotel/cardbalance')
    }
  }
}
</script>

<style lang='less'>
.card-home1 {
  height: 100%;
  width: 100%;
  background: #F5F5F5;
  .top {
    padding-top: 88px;
  }
  .recharge-card-box {
    position: relative;
    margin: 11px 8px;
    .recharge {
      img {
        display: block;
        width: 100%;
        border-radius: 8px 8px 0 0;
      }
    }
    .bottom-box {
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 21px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius:0 0 8px 8px;
      .money {
        display: flex;
        align-items: center;
        :nth-child(1) {
          line-height: 20px;
          font-size: 14px;
          color: #666666;
          text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
          padding-right: 25px;
        }
        :nth-child(2) {
          position: relative;
          line-height: 25px;
          font-size: 18px;
          color: #F9591B;
          text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
          img {
            display: inline-block;
            position: absolute;
            top: -4px;
            left: -15px;
            width: 21px;
            height: 37px;
          }
        }
        img {
          width: 70px;
          height: 37px;
        }
        

      }
      .eyes {
        width: 28px;
        height: 16px;
        img {
          width:100%;
          height: 100%;
        };
      }
    }

  }
  .info-box {
    background-color: #ffffff; 
    div {
      width: 100%;
      height: 52px;
      line-height: 52px;
      padding: 0 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      span {
        font-size: 16px;
        color: #333333;
      }
      img {
        width: 18px;
        height: 18px;
      }

    }
    .recording, .store {
      border-bottom: 1px solid #F1F1F1;
    }
  }
}

</style>